/** Saves a file the page holds (a Blob, or text) under a file name. */
export function saveAs(body: Blob | string, filename: string, type = 'text/csv;charset=utf-8') {
  const blob = body instanceof Blob ? body : new Blob([body], { type })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
